import React, { useEffect, useState } from "react";
import allDetailGroupings from "../data/detailGroupings.json";
import { getClassName } from "../helpers/utils";
import CarouselHack from "./CarouselHack";
import { GreenEnergyGenerationTitles } from "../successstories/GreenEnergyGeneration";

function Section({ section, homeEvent }) {
  const [modalLoading, setModalLoading] = useState(true);
  const [originalData, setOriginalData] = useState(allDetailGroupings);
  const [currentDetailGroupings, setCurrentDetailGroupings] = useState();
  const [selectedDetail, setSelectedDetail] = useState();
  const [selectedSuccessStories, setSelectedSuccessStories] = useState();
  const [ssIndex, setSsIndex] = useState(0);

  useEffect(() => {
    allDetailGroupings.forEach((dg, i) => {
      dg.id = i;
      dg.css = getClassName(dg.title);
      dg.details.forEach((d, j) => {
        d.id = j;
        d.dgid = i;
        d.active = false;
        d.dgcss = getClassName(dg.title);
        d.dgTitle = dg.title;
        d.css = getClassName(d.title);
        d.partial = getClassName(d.title);
        if (d.modal.partialOverride !== "") {
          d.partial = d.modal.partialOverride;
        }
        //console.log(d.css);
      });
    });
    setOriginalData(allDetailGroupings);
  }, []);

  useEffect(() => {
    let filteredGroupings = JSON.parse(JSON.stringify(originalData));
    filteredGroupings.forEach((dg) => {
      dg.details = dg.details.filter((d) => {
        return d.sectionIds.indexOf(section.id) > -1;
      });
    });
    filteredGroupings = filteredGroupings.filter((dg) => {
      return dg.details.length > 0;
    });
    setCurrentDetailGroupings(filteredGroupings);
  }, [section]);

  const onDetailClicked = (event, deet) => {
    event.preventDefault();
    setModalLoading(true);
    setSsIndex(0);
    deet.active = true;
    setSelectedDetail(deet);
    if (selectedSuccessStories !== null) {
      setSelectedSuccessStories();
    }
    //console.log(deet);
  };

  const onSuccessStoriesClicked = (event) => {
    event.preventDefault();
    setModalLoading(true);
    setSsIndex(0);
    setSelectedSuccessStories(section.successStories);
    if (selectedDetail !== null) {
      setSelectedDetail();
    }
  };

  const onIndividualSuccessStoryClicked = (event, i) => {
    event.preventDefault();
    setModalLoading(true);
    setSsIndex(i);
    setSelectedSuccessStories(section.successStories);
    if (selectedDetail !== null) {
      setSelectedDetail();
    }
  }

  const onCloseClicked = (event) => {
    event.preventDefault();
    setSelectedDetail();
  };
  const onCloseSSClicked = (event) => {
    event.preventDefault();
    setSelectedSuccessStories();
  };

  return (
    <section className="section">
      <div className="selectionContainer">
        <div className="selectionContent">
          {selectedDetail ? (
            <div
              className={
                "modalContainer " +
                (selectedDetail.dgcss + " " + selectedDetail.css)
              }
            >
              <div className="modalInnerContainer">
                <button
                  className="closeModal ui_button_icon red icon--close"
                  onClick={(event) => onCloseClicked(event)}
                ></button>
                <div className="squareIndicator">
                  <img src={selectedDetail.modal.icon.url} alt="" />
                </div>
                <div className="modalHeader">
                  <p className="dg_title">{selectedDetail.dgTitle}</p>
                  <h3 className="deets_title">{selectedDetail.title}</h3>
                </div>

                <CarouselHack cn={selectedDetail.partial} ind={ssIndex}></CarouselHack>
              </div>
            </div>
          ) : selectedSuccessStories ? (
            <div
              className={
                "modalContainer successStories " + selectedSuccessStories.class
              }
            >
              <div className="modalInnerContainer">
                <button
                  className="closeModal ui_button_icon red icon--close"
                  onClick={(event) => onCloseSSClicked(event)}
                ></button>
                <div className="squareIndicator"><img src="images/icons/success-stories-icon-white.svg" alt="" /></div>
                <div className="modalHeader">
                  <p className="dg_title">{selectedSuccessStories.title}</p>
                  <h3 className="deets_title">
                    {selectedSuccessStories.subTitle}
                  </h3>
                </div>

                <CarouselHack
                  cn={selectedSuccessStories.partial}
                  ind={ssIndex}
                ></CarouselHack>
              </div>
            </div>
          ) : (
            <img
              className="selectionImage"
              src={section.image.url}
              alt={section.image.alt}
            ></img>
          )}
        </div>
        <div className="selectionFilter">
          <div className="selectionFilterContainer">
            {currentDetailGroupings &&
              currentDetailGroupings.map((dg) => {
                let deets = dg.details.map((d, i) => {
                  return (
                    <div
                      key={i}
                      className={
                        "deets " +
                        d.title +
                        (selectedDetail && selectedDetail.id === d.id
                          ? " active"
                          : "")
                      }
                    >
                      <span className="deets_image">
                        <img src={d.icon.url} alt={d.icon.alt}></img>
                      </span>
                      <span className="deets_title">{d.title}</span>
                      <span className="deets_action icon--plus"></span>
                      <button
                        type="button"
                        onClick={(event) => onDetailClicked(event, d)}
                      ></button>
                    </div>
                  );
                });

                return (
                  <>
                    <div key={dg.id} className={"dg_title " + dg.css}>
                      {dg.title}
                    </div>
                    <>{deets}</>
                  </>
                );
              })}
            {section.id === 10 && (
              <>
                <div className="dg_title success_stories">
                  <span className="deets_title">Success stories</span>

                </div>
                <div>
                  {GreenEnergyGenerationTitles.map((x, i) => {
                    if(x === "")
                    {
                      return (<></>);
                    }
                    
                    return (
                      <div className="deets">
                        <span className="deets_title" onClick={(event) => onIndividualSuccessStoryClicked(event, (i))}>{x}</span>
                      </div>
                    )
                  })}
                </div>
              </>
            )
            }
            {section.id !== 10 && (
              <div className="dg_title success_stories">
                <span className="deets_title">Success stories</span>
                <span className="deets_action icon--plus"></span>
                <button
                  type="button"
                  onClick={(event) => onSuccessStoriesClicked(event)}
                ></button>
              </div>
            )}


          </div>
          <div className="qrCode">
            <div className="qrText">
              <p>
                <span>Scan the QR code</span> to see what we can do together!
              </p>
            </div>
            <div className="qrImage">
              <img src="images/qr/qr-recharge-earth.svg" width="auto" height="95px" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section;
